import classNames from "classnames";
import type React from "react";
import { twMerge } from "tailwind-merge";

export enum AnimationState {
  initial = "initial",
  final = "final",
  showingUp = "showingUp",
  closing = "closing",
  opening = "opening"
}

export interface LayoutBaseProps
  extends React.PropsWithChildren<React.ComponentPropsWithoutRef<"div">> {
  center?: boolean;
}

function LayoutBase({ className, children, center }: LayoutBaseProps) {
  return (
    <div
      className={twMerge(
        classNames(
          "flex h-dvh w-screen flex-col overflow-auto bg-white dark:bg-slate-950",
          center && "items-center justify-center"
        ),
        className
      )}
    >
      {children}
    </div>
  );
}

export default LayoutBase;
